import React from 'react';

import PaginationBase from '../../../common/base/PaginationBase';
import global from '../../../common/utility/global';
import { message } from 'antd';
import moment from 'moment';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import ventaGuiaRemisionService from '../../../service/logistica/reporteGuiaRemisionService';
import monedaService from '../../../service/administracion/monedaService';
import guiaRemisionService from '../../../service/logistica/guiaRemisionService';
import proyectoService from '../../../service/administracion/proyectoService';
import modalidadTrasladoService from '../../../service/logistica/modalidadTrasladoService';
import motivoTrasladoService from '../../../service/logistica/motivoTrasladoService';
import clienteService from '../../../service/administracion/clienteService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPdfRegistrado: false,
            clientes: [],
            motivos: [],
            traslados: [],
            proyectos: [],
            estado: [],
            filter: {
                cliente: "",
                idMotivo: 0,
                idTipoComprobante: 0,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                documento: '',
                codigoNombre: '',
                idEstado: 0,
                idTraslado: 0,
                idProyecto: 0,
                ...FILTER
            },

            pagination: PAGINATION
        }
    }

    handleClearFilters = () => {
        var filter = {
            cliente: "",
            idMotivo: 0,
            idTipoComprobante: 0,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: '',
            documento: '',
            codigoNombre: '',
            idEstado: 0,
            idTraslado: 0,
            idProyecto: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
       const MAX_MESES = 18;
        // Clonamos el filtro con el nuevo valor
        const filter = { ...this.state.filter, [property]: value };
    
        const { fechaInicioStr, fechaFinStr } = filter;
    
        // Solo validamos si ambas fechas existen
        if (fechaInicioStr && fechaFinStr) {
          const inicio = moment(fechaInicioStr, 'DD/MM/YYYY');
          const fin = moment(fechaFinStr, 'DD/MM/YYYY');
    
          const meses = fin.diff(inicio, 'months', true);
    
          if (meses > MAX_MESES) {
            message.error('El rango máximo permitido es de 18 meses');
            return; // ⛔ no actualiza el estado
          }
        }
    
        this.setState({ filter: filter });
        if (property === 'tipoReporte') {
            this._initPagination(filter, ventaGuiaRemisionService.paginacion);
        }
    };

    handleExportExcel = async () => {
        this.setState({
            loadingExcel: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await ventaGuiaRemisionService.excel(this.state.filter);

            this.setState({ loadingExcel: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Ventas Guia de Remisión.xlsx");
        });
    };


    handleExportPdf = async () => {
        this.setState({
            loadingPdf: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await ventaGuiaRemisionService.pdf(this.state.filter);

            this.setState({ loadingPdf: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Ventas Guia de Remisión.pdf");
        });

    };



    handlePagination = () => {
        this._handlePagination(this.state.filter);

    }
    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, ventaGuiaRemisionService.paginacion);
        var monedas = await monedaService.listar();
        const clientes = [];// await clienteService.listar();
        const estado = await guiaRemisionService.listarEstado();
        const proyectos = await proyectoService.listar();
        const traslados = await modalidadTrasladoService.listar();
        const motivosTraslado = await motivoTrasladoService.listar();

        if (monedas !== undefined)
            monedas.splice(0, 0, { id: '0', nombre: "MONEDA ORIGINAL" });

        this.setState({
            loadingSource: false,
            clientes: clientes ? clientes : [],
            monedas: monedas ? monedas : [],
            motivos: motivosTraslado ? motivosTraslado : [],
            traslados: traslados ? traslados : [],
            proyectos: proyectos ? proyectos : [],
            estado: estado ? estado : [],

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Reporte General de GRE – Remitente"
                    onSearch={this.handlePagination}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    clientes={this.state.clientes}
                    onChange={this.handleChange}
                    estado={this.state.estado}
                    motivo={this.state.motivos}
                    modalidad={this.state.traslados}
                    proyectos={this.state.proyectos}
                    onKeyUpSearch={this.handleKeyUpInput}

                />

                <ResultList
                    pagination={this.state.pagination}
                    columnVisible={this.state.columnVisible}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    onExportExcel={this.handleExportExcel}
                    //onExportPdf={this.handleExportPdf}
                    onChange={this._handleChangePagination}
                />
            </div>
        )
    }
}